export enum LogType {
  Team,
  Device,
  Command,
}
